import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from './locales/es/common.json';
import en from './locales/en/common.json';

export const SUPPORTED_LANGUAGES = ['es', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/**
 * Cada idioma detectado se reduce a su base (`es-CO` → `es`) ANTES de elegir. Sin esto, i18next busca primero una coincidencia EXACTA en toda
 * la lista del navegador: en Android `navigator.languages` es `["es-CO","en-US","en","es-419","es"]`, el `en` exacto (tercero) ganaba a `es-CO`
 * y los teléfonos colombianos con inglés como idioma secundario veían la aplicación en inglés (M-1).
 */
export const DETECTION_OPTIONS = {
  order: ['localStorage', 'navigator'],
  caches: ['localStorage'],
  lookupLocalStorage: 'logistrade_language',
  convertDetectedLanguage: (lng: string) => lng.split(/[-_]/)[0].toLowerCase(),
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { common: es },
      en: { common: en },
    },
    ns: ['common'],
    defaultNS: 'common',
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    interpolation: { escapeValue: false },
    detection: DETECTION_OPTIONS,
  });

// `<html lang>` sigue al idioma real: lectores de pantalla, corrector y el traductor de Chrome (que ofrecía «traducir del inglés» una página ya en español).
const sincronizarLang = (lng?: string) => { if (typeof document !== 'undefined' && lng) document.documentElement.lang = lng.split(/[-_]/)[0]; };
i18n.on('languageChanged', sincronizarLang);
sincronizarLang(i18n.language);

export default i18n;
